import { Component, OnInit, Input } from '@angular/core';
import { MotesPaths } from '@motes-sdk/models';
import { Animations } from '../animations';
import { AutoSub, AutoSubOnDestroy } from '../providers';
import { MotesCookieService, CookieSection } from './cookie.service';

@AutoSubOnDestroy()
@Component({
    selector: 'motes-cookie',
    templateUrl: './cookie.component.html',
    styleUrls: ['./cookie.component.scss'],
    animations: [Animations.fadeIn(200), Animations.slideFromTop(300)]
})
export class CookieComponent implements OnInit {

    public CookieSection = CookieSection;
    public sections: string[] = [];
    public date: string = '';
    public domains: string = '';
    @Input() section: CookieSection = CookieSection.TERMS;
    @Input() showCookies: boolean = false;

    // Expose to view
    public MotesPaths = MotesPaths;

    constructor(private cookieInfoService: MotesCookieService) {

    }

    ngOnInit() {
        this.genSections();
        this.genScope();
        AutoSub(this).reg['cookieState'] = this.cookieInfoService.watchCookieInfoStatus().subscribe((bool) => {
            if(bool.section) this.section = bool.section;
            this.showCookies = bool.show;
        });
    }

    public changeSection(section: CookieSection): void {
        this.section = section;
    }

    public closeCookies(): void {
        this.cookieInfoService.showCookieInfo(false);
    }

    private genSections() {
        for(let s in CookieSection) {
            if(s != CookieSection.NONE) this.sections.push(s);
        }
    }

    private genScope() {
        this.date = '27.01.22';
        this.domains = "storyhunt.dk, storyhunt.app, storyhunt.io, knowyourbro.dk, copenhagenlocalwalks.dk"
    }
}
